import { Component, OnInit } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { AfTranslateDirective } from '../../modules/translate/directive/af-translate.directive';
import { ContextFactory } from '@shared/factories/context/context.factory';
import { ModalServiceService } from '@shared/services/modal-service/modal-service.service';
import { FieldTypeRichTextComponent } from "../field-type-rich-text/field-type-rich-text/field-type-rich-text.component";

@Component({
    selector: 'concept-info',
    templateUrl: './concept-info.component.html',
    standalone: true,
    imports: [AfTranslateDirective, FieldTypeRichTextComponent]
})
export class ConceptInfoComponent implements OnInit {
  concept: any = this.dialogConfig.data.concept;
  conceptInfo:any = {};
  constructor( private context: ContextFactory,
    private modalService: ModalServiceService,
    private dialogRef: DynamicDialogRef<ConceptInfoComponent>,
    private dialogConfig: DynamicDialogConfig){ }

  ngOnInit(): void {
    let description:any = this.extractRelatedOrReferences('data-related="', this.concept.description);
    this.conceptInfo.description = this.extractRelatedOrReferences('data-references="', description);
  }

  extractRelatedOrReferences(type:any, description:any){
    if(description.indexOf('<a') !== -1){
      let aSplit = description.split('<a ');
      for(let i = 0; i < aSplit.length; i++){
        let aTag = aSplit[i];
        if(aTag.indexOf(type) !== -1){
          aTag = aTag.replace('href="#"','');
          aSplit[i] = aTag.replace(type,'(click)="openRelated(');
        }
      }
      return aSplit.join('<a ')
    }else{
      return description;
    }
  }

  openRelated(item:any){
    item.modal==='related-information'? this.modalService.relatedInformationModal([item]) : this.openReferences(item, this);
  }

  openReferences(item:any, child:any){
    let registerItem ={
      'Distinct ID': this.context.user.externalId,
      'Client ID': this.context.user.companyExternalId,
      'event':'open legal docs',
      'Concept Name': sessionStorage.getItem('breadcrumbConcept') + child.conceptInfo.concept.title,
      'Centinela product': this.context.settings.defaultProduct
    }
    this.modalService.lawInfoModal(registerItem, [item])
  }

  handleAccept() {
    this.dialogRef.close({result: 'ok'});
  }

  handleDismiss() {
    this.dialogRef.close({result:'cancel'});
  }
}
